module.exports = __webpack_public_path__ + "img/画板 5@3x.46dcb8d8.png";